import type { HTMLAttributes } from 'react'
import { cn } from '../cn.ts'

/** Resting card: hairline only, no shadow (§21.1). */
export function Card({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-card border border-line-1 bg-card', className)} {...rest} />
}

/** Floating surface (menus, popovers, ⌘K): the only elements that get a shadow. */
export function Sheet({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('rounded-panel border border-line-1 bg-card shadow-2', className)} {...rest} />
}

/** Exactly one per screen: cool glow top left, warm glow top right (§21.1). */
export function PulseSheet({ className, style, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-panel border border-line-1 bg-card', className)}
      style={{
        backgroundImage:
          'radial-gradient(circle at 0% 0%, var(--pop-glow), transparent 55%), radial-gradient(circle at 100% 0%, var(--apricot-glow), transparent 50%)',
        ...style,
      }}
      {...rest}
    />
  )
}
